module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "manara-school-building.e940de0e.jpg" + "?" + Date.now();